import React, { useState } from "react";
import { Sun, Moon, ArrowLeft } from "lucide-react";

type Project = {
  name: string;
  description: string;
  image: string;
  link: string;
  platform: string;
};

const projectList: Project[] = [
  {
    name: 'Zoohouse',
    description: '"ZooHouse.az" Laravel(php) Çərçivəsi ilə yaradılmış E-commerce tipli vebsaytdır. Satışlar sayt üzərindən onlayn qaydada aparılır. Saytın admin paneli, məhsullardan saytın dizayınına qədər dəyişiklik etməyi qarşılayır',
    image: 'assets/images/zoo.png',
    link: 'https://zoohouse.az',
    platform: 'Vebsayt . Ecommerce  . Admin Panel'
  },
  {
    name: 'Master',
    description: '"Master.az" geniş məhsul çeşidi təklif edən hərtərəfli onlayn satış platformasıdır. Admin paneli vasitəsilə bütün məhsulların idarə edilməsi mümkündür.',
    image: 'assets/images/master.png',
    link: 'https://master.az',
    platform: 'Vebsayt . Ecommerce . Admin Panel'
  },
  {
    name: 'Velioglu Mebel',
    description: '"Velioglumebel.az" yüksək keyfiyyətli mebellərin nümayişi üçün portfoliodur. Sayt üzərindən məhsullar haqqında məlumat əldə etmək mümkündür.',
    image: 'assets/images/velioglu.png',
    link: 'https://velioglumebel.az',
    platform: 'Vebsayt . Portfolio . Mebel'
  },
  {
    name: 'Skypax Travel',
    description: '"Skypaxtravel.com" səyahət xidmətləri və təklif olunan istiqamətlər haqqında məlumat verən portfoliodur. Səyahət planlamaq üçün məlumatlar təmin edir.',
    image: 'assets/images/skypax.png',
    link: 'https://skypaxtravel.com',
    platform: 'Vebsayt . Portfolio . Səyahət'
  },
  {
    name: 'The Marine GP',
    description: '"Themarinegp.com" gəmiqayırma sənayesi üçün portfoliodur, müxtəlif layihələr və xidmətləri təqdim edir.',
    image: 'assets/images/marine.png',
    link: 'https://themarinegp.com',
    platform: 'Vebsayt . Portfolio . Gəmiqayırma'
  },
  {
    name: 'American Avto',
    description: '"Americanavto.az" avtomobil ehtiyat hissələrinin satışı ilə məşğul olan onlayn mağazadır. Məhsullar sayt üzərindən əldə edilə bilər.',
    image: 'assets/images/americanavto.png',
    link: 'https://americanavto.az',
    platform: 'Vebsayt . Ecommerce . Avtomobil'
  },
  {
    name: 'ETA',
    description: '"Eta.org.az" müxtəlif təhsil qiymətləndirmələri təklif edən onlayn test platformasıdır. İstifadəçilər müxtəlif testlərdən keçə bilər.',
    image: 'assets/images/eta.png',
    link: 'https://eta.org.az',
    platform: 'Vebsayt . Təhsil Texnologiyası . Test Platforması'
  },
  {
    name: 'Sənan Nəsirli Kurikulum',
    description: '"Kurikulum - Sənan Nəsirli" tətbiqi kurikulum müəllimi Sənan Nəsirli tərəfindən hərkəs üçün nəzərdə tutulmuş və tamamilə ödənişsiz sınaqlardan, həmçinin onların izahatlarından ibarət xüsusi sifarişli tətbiqdir. Tətbiqin rahat interfeysi və rest api sistemi ilə qurulmuş admin paneli vardır. Bütün idarəetmələr admin paneldən mümkündür.',
    image: 'assets/images/kurikulum.png',
    link: 'https://play.google.com/store/apps/details?id=com.kurikulum.senannasirli',
    platform: 'Mobil tətbiq . Quiz . Admin Panel'
  },
  {
    name: 'Dini dərslər',
    description: '"Dini dərslər" adlı mobil tətbiq dini təhsil və resursları təmin edir. İstifadəçilər müxtəlif dini mövzular üzrə dərslər əldə edə bilərlər.',
    image: 'assets/images/dinidersler.png',
    link: 'https://play.google.com/store/apps/details?id=com.dinidersler',
    platform: 'Mobil tətbiq . Təhsil . Dini Resurslar'
  },
  {
    name: 'Dr. Qorxmaz Azimov',
    description: '"Drqorxmazazimov.com" Dr. Qorxmaz Azimovun iş və nailiyyətlərini təqdim edən peşəkar portfoliodur.',
    image: 'assets/images/qorxmazazimov.png',
    link: 'https://drqorxmazazimov.com',
    platform: 'Vebsayt . Tibbi Portfolio . Həkim'
  },
  {
    name: 'Diyetoloq Leyla',
    description: '"Diyetoloqleyla.com" Dr. Leyla Zülfuqarlının diyetoloq kimi xidmət və ixtisasını təqdim edən peşəkar portfoliodur.',
    image: 'assets/images/diyetoloqleyla.png',
    link: 'https://diyetoloqleyla.com',
    platform: 'Vebsayt . Tibbi Portfolio . Diyetoloq'
  },
  {
    name: 'Plastik Cərrahiyə',
    description: '"Plastikcerrahiyye.az" Dr. Ruslan Resulun plastik cərrahiyyə sahəsindəki işini təqdim edən peşəkar portfoliodur.',
    image: 'assets/images/ruslanresul.png',
    link: 'https://plastikcerrahiyye.az',
    platform: 'Vebsayt . Tibbi Portfolio . Plastik Cərrahiyyə'
  },
  // Defunct Websites and Mobile Applications
  {
    name: 'Burada',
    description: '"Burada" adlı mobil tətbiq onlayn alış-veriş üçün nəzərdə tutulmuşdur.',
    image: 'assets/images/defapp.png',
    link: 'N/A',
    platform: 'Mobil tətbiq . Alış-veriş . İstifadədən çıxarılıb'
  },
  {
    name: 'Həkim qəbulu',
    description: '"Həkim qəbulu" adlı mobil tətbiq, həkimlər ilə pasiyentlər arasındakı əlaqəni rahatraşdırmaq üçün yaradılıb. Tətbiqin rahat interfeysi və rest api sistemi ilə qurulmuş admin paneli vardır. Bütün idarəetmələr admin paneldən mümkündür.',
    image: 'assets/images/hekim.png',
    link: 'https://play.google.com/store/apps/details?id=az.hekimqebulu.customer',
    platform: 'Mobil tətbiq . Booking . Admin Panel . İstifadədən çıxarılıb'
  },
  {
    name: 'Asansat',
    description: '"Asansat" adlı platforma ikinci əl məhsulların satışı üçün nəzərdə tutulmuşdur.',
    image: 'assets/images/defweb.jpg',
    link: 'N/A',
    platform: 'Vebsayt . İkinci əl . İstifadədən çıxarılıb'
  },
  {
    name: 'Sizinfilm',
    description: '"Sizinfilm" Netflix-ə bənzər film saytıdır, müxtəlif filmləri təklif edir.',
    image: 'assets/images/defweb.jpg',
    link: 'N/A',
    platform: 'Vebsayt . Film Platforması . İstifadədən çıxarılıb'
  },
  {
    name: 'W-telecome',
    description: '"W-telecome" mobil telefonların satışı ilə məşğul olan onlayn platformadır.',
    image: 'assets/images/defweb.jpg',
    link: 'N/A',
    platform: 'Vebsayt . Mobil Telefonlar . İstifadədən çıxarılıb'
  },
  {
    name: 'Dr. Azər Əbilzadə',
    description: '"Drazerebilzade.az" Dr. Azər Əbilzadənin peşəkar portfoliodur.',
    image: 'assets/images/defweb.jpg',
    link: 'N/A',
    platform: 'Vebsayt . Tibbi Portfolio . Həkim . İstifadədən çıxarılıb'
  },
];

const ProjectsScreen: React.FC = () => {
  const [isDark, setIsDark] = useState(true);

  return (
    <div className={`${isDark ? "bg-gray-900 text-white" : "bg-gray-50 text-gray-900"} min-h-screen transition-colors duration-500`}>
      {/* Header */}
      <div className="flex justify-between items-center px-6 py-6 border-b border-gray-700 dark:border-gray-600">
        <button
          onClick={() => window.location.href = "/"} 
          className="flex items-center gap-2 px-4 py-2 bg-gray-700 dark:bg-gray-200 text-white dark:text-gray-900 rounded-lg hover:scale-105 transition-all shadow-md"
        >
          <ArrowLeft size={18} /> Geri
        </button>
        <h1 className="text-3xl font-bold text-center flex-1">Layihələr</h1>
        <button
          onClick={() => setIsDark(!isDark)}
          className={`p-2 rounded-full ${isDark ? "bg-gray-800 text-yellow-400" : "bg-white text-gray-800"} shadow-lg hover:scale-110 transition-all`}
        >
          {isDark ? <Sun size={20} /> : <Moon size={20} />}
        </button>
      </div>

      {/* Projects Grid */}
      <div className="p-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {projectList.map((proj, idx) => (
          <div
            key={idx}
            className="bg-gray-800 dark:bg-gray-100 text-white dark:text-gray-900 rounded-lg shadow-lg overflow-hidden transform hover:scale-105 hover:shadow-2xl transition-all cursor-pointer flex flex-col"
            onClick={() => proj.link !== "N/A" && window.open(proj.link, "_blank")}
          >
            <div className="flex justify-center items-center h-48 bg-gray-700 dark:bg-gray-200">
              <img
                src={proj.image}
                alt={proj.name}
                className="object-contain max-h-full"
              />
            </div>
            <div className="p-4 flex flex-col gap-2 flex-1">
              <h2 className="text-xl font-semibold">{proj.name}</h2>
              <p className="text-gray-300 dark:text-gray-700 text-sm flex-1">{proj.description}</p>
              <p className="text-gray-400 dark:text-gray-600 text-sm">{proj.platform}</p>
              {proj.link !== "N/A" && (
                <span className="mt-2 text-blue-400 underline text-sm">Sayta Bax</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectsScreen;
